<div class="status">

    <div class="status-text">
        <ng-container *ngIf="statusService.text != ''">
            {{statusService.text}}
        </ng-container>

        <ng-container *ngIf="statusService.text == ''">
            <ng-container *ngIf="isJob">
                <div (click)="openJobDialog()">{{statusText}}</div>
            </ng-container>
            <ng-container *ngIf="!isJob">
                {{statusText}}
            </ng-container>
        </ng-container>

    </div>

    <div class="actions">
        <button mat-raised-button class="mat-elevation-z1" (click)="kiosMode()">Kios Mode</button>
        <button mat-raised-button class="mat-elevation-z1" (click)="bankSyncJob()">Bank Sync</button>
        <button mat-raised-button class="mat-elevation-z1" (click)="backupJob()">Backup</button>
    </div>
</div>
